import { hasRouteValue } from "@/Composables/useRouteSupport";
import {
  BookOpenIcon,
  CalendarIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  HomeIcon,
  RectangleStackIcon,
  UserGroupIcon,
} from "@heroicons/vue/24/outline";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default function repNavigation() {
  const page = usePage();
  const summitEventId = computed(() => page.props?.summit?.id ?? null);

  const navigation = [
    { name: "Dashboard", route: "dashboard.index", icon: HomeIcon, component: "Rep/Dashboard" },
    {
      name: "Program Maintenance",
      subName: "(Blue Book)",
      route: "program-maintenance.index",
      icon: BookOpenIcon,
      component: "Rep/ProgramMaintenance",
    },
    {
      name: "Calendar of Events",
      route: "upcoming-events.index",
      component: "UpcomingEvents/Index",
      icon: CalendarIcon,
    },
    // ! Reps do not get access to the Blue Book Platform
    {
      name: "Contacts",
      icon: UserGroupIcon,
      children: [
        {
          name: "MSD Board Members",
          route: "contacts.msd-board-members.index",
          component: "Contacts/MsdBoardMembers",
        },
        {
          name: "MSD Contacts",
          route: "contacts.msd-contacts.index",
          component: "Contacts/MsdContacts",
        },
        {
          name: "Member Companies",
          route: "contacts.member-companies.index",
          component: "Contacts/MemberCompanies",
        },
        {
          name: "Suppliers",
          route: "contacts.suppliers.index",
          component: "Contacts/Suppliers",
        },
        // { name: "Rep Groups", route: "contacts.reps.index", component: "Contacts/Reps" },
        {
          name: "My Company Profile/Contacts",
          route: "company-profile.index",
          component: "CompanyProfile/Index",
        },
        {
          name: "Buyers",
          route: "contacts.buyers.index",
          component: "Contacts/Buyers",
        },
      ],
    },
    { name: "Committees", route: "committees.index", icon: RectangleStackIcon, component: "Committees/Index" },
    // { name: "Contacts", route: "contacts.index", icon: UsersIcon, component: "Contacts/Index" },
    // { name: "Live Events", route: "events.index", icon: CalendarIcon, component: "Events/Index" },
    {
      name: "Shows",
      icon: CurrencyDollarIcon,
      children: [
        {
          name: "Upcoming/Next Shows",
          route: "events.next-shows.index",
          component: "Events/NextShows/Index",
        },
        {
          name: "Archived Shows",
          route: "events.archived-shows.index",
          component: "Events/ArchivedShows/Index",
        },
        ...(hasRouteValue(summitEventId.value)
          ? [
              {
                name: "Summit Registration",
                route: "events.event.suppliers.index",
                params: { event: summitEventId.value },
                component: "Events/Summit/Registration",
              },
            ]
          : []),
      ],
    },
    // {
    //   name: "Events",
    //   icon: CalendarIcon,
    //   children: [
    //     { name: "Event Calendar", route: "upcoming-events.index", component: "UpcomingEvents/Index" },
    //     // {
    //     //   name: "Events Calendar",
    //     //   route: "events.calendar.index",
    //     //   component: "Events/Calendar/Index",
    //     // },
    //     { name: "Virtual Shows", route: "events.index", component: "Events/Index" },
    //     // {
    //     //   name: "Virtual Shows - Archived",
    //     //   route: "events.archived.index",
    //     //   component: "Events/Archived/Index",
    //     // },
    //   ],
    // },
    { name: "Reports", route: "reports.index", icon: ChartBarIcon, component: "Reports/Index" },
  ];

  return {
    navigation,
  };
}
